import React from 'react';
import throttle from 'lodash/throttle';

import getDisplayName from 'helpers/getDisplayName';




function withScreenSize(WrappedComponent) {
	class WithScreenSize extends React.Component {

		constructor(props) {
			super(props);

			this.state = this.getScreenInfo();

			const handleResize = () => {
				this.setState(this.getScreenInfo());
			};

			// Avoid excessive updates.
			this.throttledResize = throttle(handleResize, 100);
		}

		componentDidMount() {
			window.addEventListener('resize', this.throttledResize);
		}

		// Cancel the trailing throttled invocation and clean up event listener.
		componentWillUnmount() {
			this.throttledResize.cancel();
			window.removeEventListener('resize', this.throttledResize);
		}

		getScreenInfo() {
			return {
				screenWidth: window.innerWidth,
				screenHeight: window.innerHeight
			};
		}

		render() {
			return (
				<WrappedComponent
					{...this.props}
					screenWidth={this.state.screenWidth}
					screenHeight={this.state.screenHeight}
				>
					{this.props.children}
				</WrappedComponent>
			);
		}
	}

	WithScreenSize.displayName = `WithScreenSize(${getDisplayName(WrappedComponent)})`;

	return WithScreenSize;
}

export default withScreenSize;



// WEBPACK FOOTER //
// ./src/ui/hoc/withScreenSize.jsx